import KeenSlider from "https://cdn.skypack.dev/pin/keen-slider@v6.7.0-LKl0HtBlpKLwpmTQiIJc/mode=imports,min/optimized/keen-slider.js";
const { getElement, getElements, formatMoney } = window.BAO.Utils,
    { useArrows } = window.BAO.Carousel.plugins;
   
class bespokeVisualiser extends window.BAO.CustomElement() {
    connectedCallback() {
        super.connectedCallback(),
            (this.selectors = { charm: "[data-visualiser-charm]", quantity: "[data-visualiser-quantity]", infoShow: "[data-visualiser-info-show]", charmFilter: "[data-visualiser-charm-filter]" }),
            (this.visualiser = { product: {}, charms: [] }),
            (this.baseVariantId = this.els.addToCart.element.dataset.baseProduct),
            (this.baseVariantName = this.els.addToCart.element.dataset.variantName),
            (this.baseVariantPrice = parseInt(this.els.addToCart.element.dataset.variantPrice)),
            (this.bvCanvas = new BVCanvas()),
            (this.urlParams = new URLSearchParams(window.location.search));
        const defaultType = this.urlParams.get("productType"),
            defaultStyle = this.urlParams.get("productStyle");
        let defaultStage = "type";
        defaultType ? (defaultStage = "style") : defaultType && defaultStyle && (defaultStage = "length"),
            (this.canvas = this.els.canvas.element),
            (this.currentStep = defaultType ? this.els.step.elements.length : 1),
            (this.currentStage = defaultStage),
            (this.activeStage = null),
            (this.productType = null),
            (this.productStyle = null),
            (this.productLength = null),
            (this.charmFilter = document.querySelectorAll(this.selectors.charmFilter)[0].dataset.material),
            (this.charmMax = 0),
            (this.typeCharmMax = 0),
            (this.summary = !0),
            (this.designSlideOut = !0),
            this.clickProductType(defaultType);
    }
    setupListeners() {
        super.setupListeners(),
            (this.handleClick = this.handleClick.bind(this)),
            this.els.next_step?.elements.forEach((trigger) => {
                this.listeners.add(trigger, "click", () => {
                    trigger.dataset.productType
                        ? ((this.productType = trigger.dataset.productType),
                          (this.collection = trigger.dataset.collection),
                          (this.charmMax = parseInt(trigger.dataset.max)),
                          (this.typeCharmMax = parseInt(trigger.dataset.max)),
                          (this.charmScale = parseInt(trigger.dataset.charmScale)),
                          (this.charmPosition = parseInt(trigger.dataset.charmPosition)),
                          (this.placeholderImage = trigger.dataset.placeholderImage),
                          this.currentStep++)
                        : this.currentStep++;
                });
            }),
            this.els.stage_show?.elements.forEach((trigger) => {
                this.listeners.add(trigger, "click", () => {
                    trigger.ariaDisabled !== "true" && ((this.currentStage = trigger.dataset.stage), (this.activeStage = trigger.dataset.stage));
                });
            }),
            this.els.close.elements.forEach((trigger) => {
                this.listeners.add(trigger, "click", () => {
                    this.activeStage = null;
                });
            }),
            this.els.info_hide?.elements.forEach((trigger) => {
                this.listeners.add(trigger, "click", () => {
                    this.infoSlide = "";
                });
            }),
            this.els.product_type?.elements.forEach((trigger) => {
                this.listeners.add(trigger, "click", () => {
                    trigger.classList.contains("vis-Info_Square-selected") ||
                        ((this.productType = trigger.dataset.productType),
                        (this.collection = trigger.dataset.collection),
                        (this.charmMax = parseInt(trigger.dataset.max)),
                        (this.typeCharmMax = parseInt(trigger.dataset.max)),
                        (this.charmScale = parseInt(trigger.dataset.charmScale)),
                        (this.charmPosition = parseInt(trigger.dataset.charmPosition)),
                        (this.placeholderImage = trigger.dataset.placeholderImage),
                        (this.activeStage = null));
                });
            }),
            this.listeners.add(this, "click", this.handleClick),
            this.els.summary_button?.elements.forEach((trigger) => {
                this.listeners.add(trigger, "click", () => {
                    trigger.disabled || (this.summary = !1);
                });
            }),
            this.els.summary_close?.elements.forEach((trigger) => {
                this.listeners.add(trigger, "click", () => {
                    this.summary = !0;
                });
            }),
            this.els.summary_edit?.elements.forEach((trigger) => {
                this.listeners.add(trigger, "click", () => {
                    trigger.dataset.summaryEdit !== "charms" && (trigger.dataset.summaryEdit === "design" ? trigger.disabled || (this.designSlideOut = !1) : ((this.summary = !0), (this.activeStage = trigger.dataset.summaryEdit)));
                });
            }),
            this.els.design_close?.elements.forEach((trigger) => {
                this.listeners.add(trigger, "click", () => {
                    this.designSlideOut = !0;
                });
            }),
            this.els.design_option?.elements.forEach((trigger) => {
                this.listeners.add(trigger, "click", () => {
                    (this.baseVariantId = trigger.dataset.variantId), (this.baseVariantName = trigger.dataset.variantName), (this.baseVariantPrice = parseInt(trigger.dataset.variantPrice));
                });
            }),
            console.log('this == ', this)
            // this.listeners.add(this.els.addToCart?.element, "click", () => {
            //     BVSummary.addToCart(this.visualiser, this);
            // }),
          this.els.addToCart?.elements.forEach(btn => {
   this.listeners.add(btn, 'click', () => {
    BVSummary.addToCart(this.visualiser, this);
   });
 });
            this.listeners.add(document, "visualiser:remove", (e) => {
                this.updateCharm(parseInt(e.detail.index), "remove");
            }),
            this.listeners.add(document, "visualiser:reorder", (e) => {
                this.updateCharm(e.detail.charms, "reorder");
            }),
            this.listeners.add(document, "visualiser:updatePreview", (e) => {
                this.updateProduct("previewImage", e.detail.previewImage, !1);
            }),
            this.renderListeners();
    }
    productEngravingUpdate(e) {
        const { productId, font, text } = e.detail,
            product_id = parseInt(productId);
        this.visualiser.charms.forEach((charm) => {
            charm.id === product_id && ((charm.engraving_font = font), (charm.engraving_text = text));
        }),
            BVSummary.render(this.visualiser);
    }
    handleClick(e) {
        if (e.target.closest(this.selectors.quantity)) {
            const trigger = e.target.closest(this.selectors.quantity),
                object = JSON.parse(getElement(".vis-Charms_Object", { context: trigger.closest(this.selectors.charm) }).innerText)[0];
            trigger.closest(this.selectors.charm).dataset.engravingText &&
                ((object.engraving_text = trigger.closest(this.selectors.charm).dataset.engravingText), (object.engraving_font = trigger.closest(this.selectors.charm).dataset.engravingFont)),
                this.updateCharm(object, trigger.dataset.qtyType);
        }
        if (e.target.closest(this.selectors.infoShow)) {
            e.preventDefault(), e.stopPropagation();
            const trigger = e.target.closest(this.selectors.infoShow);
            this.infoSlide = trigger.dataset.handle;
        }
        if (e.target.closest(this.selectors.charmFilter)) {
            const trigger = e.target.closest(this.selectors.charmFilter);
            this.charmFilter = trigger.dataset.material;
        }
    }
    renderCharmEdit() {
        this.els.summary_edit?.elements.forEach((trigger) => {
            this.listeners.add(trigger, "click", () => {
                (this.summary = !0), (this.activeStage = trigger.dataset.summaryEdit);
            });
        });
    }
    renderListeners() {
        this.els.product_style?.elements.forEach((trigger) => {
            this.listeners.add(trigger, "click", async () => {
                (this.productStyle = trigger.dataset.productStyle),
                    (this.productId = trigger.dataset.productId),
                    (this.productPrice = trigger.dataset.productPrice),
                    (this.productImage = trigger.dataset.productImage),
                    (this.productLengthImage = trigger.dataset.productLengthImage),
                    (this.charmSpacingItems = trigger.dataset.productSpacing),
                    (this.charmMaxUpdate = this.typeCharmMax),
                    (this.activeStage = null),
                    (this.hideLength = trigger.dataset.productDefault),
                    trigger.dataset.productDefault === "true" &&
                        getElements(".vis-Info_CapsuleList").forEach((variant) => {
                            variant.ariaHidden === "false" && variant.firstElementChild.click();
                        });
            });
        }),
            this.els.product_length?.elements.forEach((trigger) => {
                trigger.ariaDisabled === "false" &&
                    this.listeners.add(trigger, "click", () => {
                        (this.productLength = trigger.dataset.productLength), (this.variantId = trigger.dataset.variantId), (this.charmMaxUpdate = trigger.dataset.productMaxCharms ?? this.typeCharmMax), (this.activeStage = null);
                    });
            }),
            this.els.product_material?.elements.forEach((trigger) => {
                this.listeners.add(trigger, "click", () => {
                    this.productMaterial = trigger.dataset.productMaterial;
                });
            });
    }
    clickProductType(collection) {
        collection &&
            this.els.product_type?.elements.forEach((trigger) => {
                trigger.dataset.collection === collection && trigger.click();
            });
    }
    clickProductStyle(style) {
        style &&
            this.els.product_style?.elements.forEach((trigger) => {
                trigger.dataset.productStyle === style && trigger.click();
            });
    }
    get infoSlide() {
        return this._infoSlide;
    }
    set infoSlide(productHandle) {
        productHandle
            ? fetch(`/products/${productHandle}?sections=bespoke-visualiser-info`)
                  .then((response) => response.json())
                  .then((responseJSON) => {
                      (getElement(".vis-CharmInfo_Target", { context: this.els.info.element }).innerHTML = responseJSON["bespoke-visualiser-info"]),
                          (this.els.info.element.ariaHidden = productHandle.length <= 0),
                          this.initialiseInfoCarousel();
                  })
                  .catch((e) => {
                      console.error(e);
                  })
            : (this.els.info.element.ariaHidden = productHandle.length <= 0),
            (this._infoSlide = productHandle);
    }
    initialiseInfoCarousel() {
        if (this.els["info-slider"])
            return new KeenSlider(this.els["info-slider"].element, { selector: this.els["info-slide"].elements, loop: !0, slides: { origin: "center", perView: 1 } }, [
                (carousel) => {
                    carousel.on("animationStarted", () => {
                        const nextActiveIndex = carousel.track.absToRel(carousel.animator.targetIdx || 0);
                        carousel.slides.forEach((slide, index) => {
                            slide.setAttribute("aria-current", index === nextActiveIndex);
                        }),
                            (this.activeIndex = nextActiveIndex);
                    });
                },
                useArrows({ next: this.els["info-next"].element, previous: this.els["info-previous"].element }),
            ]);
    }
    initialiseDesignCarousel() {
        if (this.els["design-slider"])
            return new KeenSlider(this.els["design-slider"].element, { selector: this.els["design-slide"].elements, loop: !0, slides: { origin: "center", perView: 1 } }, [
                (carousel) => {
                    carousel.on("animationStarted", () => {
                        const nextActiveIndex = carousel.track.absToRel(carousel.animator.targetIdx || 0);
                        carousel.slides.forEach((slide, index) => {
                            slide.setAttribute("aria-current", index === nextActiveIndex);
                        }),
                            (this.activeIndex = nextActiveIndex);
                    });
                },
                useArrows({ next: this.els["design-next"].element, previous: this.els["design-previous"].element }),
            ]);
    }
    get currentStep() {
        return this._currentStep;
    }
    set currentStep(currentStep) {
        this.els.step.elements.forEach((step) => {
            step.ariaHidden = parseInt(step.dataset.step) !== currentStep;
        }),
            (this._currentStep = currentStep);
    }
    get currentStage() {
        return this._currentStage;
    }
    set currentStage(currentStage) {
        this.els.stage.elements.forEach((stage) => {
            stage.ariaHidden = stage.dataset.stage !== currentStage;
        }),
            this.els.stage_show.elements.forEach((stageShow) => {
                stageShow.classList.toggle("vis-Visualiser_Step-active", stageShow.dataset.stage === currentStage);
            }),
            (this._currentStage = currentStage);
    }
    get activeStage() {
        return this._activeStage;
    }
    set activeStage(activeStage) {
        this.els.stage.elements.forEach((stage) => {
            stage.ariaCurrent = stage.dataset.stage === activeStage;
        }),
            activeStage === "charms" ? (getElement(".vis-Visualiser_Steps").ariaHidden = !0) : (getElement(".vis-Visualiser_Steps").ariaHidden = !1),
            activeStage && activeStage !== "charms" ? (getElement(".vis-Visualiser_InfoBackdrop", { context: this }).ariaHidden = !1) : (getElement(".vis-Visualiser_InfoBackdrop", { context: this }).ariaHidden = !0),
            (this._activeStage = activeStage);
    }
    get baseVariantId() {
        return this._baseVariantId;
    }
    set baseVariantId(id) {
        this.updateProduct("base_variant_id", id),
            this.els.design_option.elements.forEach((option) => {
                option.classList.toggle("vis-Design_Option-selected", option.dataset.variantId === id);
            }),
            (this._baseVariantId = id);
    }
    get baseVariantPrice() {
        return this._baseVariantPrice;
    }
    set baseVariantPrice(price) {
        this.updateProduct("base_variant_price", price), (this._baseVariantPrice = price);
    }
    get baseVariantName() {
        return this._baseVariantName;
    }
    set baseVariantName(name) {
        this.updateProduct("base_variant_name", name), (this._baseVariantName = name);
    }
    get productType() {
        return this._productType;
    }
    set productType(productType) {
        this.els.product_type.elements.forEach((product_type) => {
            product_type.classList.toggle("vis-Info_Square-selected", product_type.dataset.productType === productType), (product_type.ariaSelected = product_type.dataset.productType === productType);
        }),
            this.visualiser.product.type && this.resetSelected(),
            this.updateProduct("type", productType, !1, "style"),
            (this._productType = productType);
    }
    get placeholderImage() {
        return this._placeholderImage;
    }
    set placeholderImage(image) {
        (this._placeholderImage = image), (this.els.placeholder.element.style.backgroundImage = `url("${image}")`);
    }
    get productStyle() {
        return this._productStyle;
    }
    set productStyle(productStyle) {
        this.els.product_style?.elements.forEach((product_style) => {
            product_style.classList.toggle("vis-Info_Square-selected", product_style.dataset.productStyle === productStyle), (product_style.ariaSelected = product_style.dataset.productStyle === productStyle);
        }),
            this.updateProduct("style", productStyle, !1, "length"),
            (this._productStyle = productStyle);
    }
    get productId() {
        return this._productId;
    }
    set productId(id) {
        getElements("[data-selected-product-id]", { context: this }).forEach((element) => {
            element.ariaHidden = element.dataset.selectedProductId !== id;
        }),
            this.updateProduct("id", parseInt(id)),
            (this._productId = id);
    }
    get productPrice() {
        return this._productPrice;
    }
    set productPrice(price) {
        this.updateProduct("price", parseInt(price)), (this._productPrice = price);
    }
    get productImage() {
        return this._productImage;
    }
    set productImage(image) {
        (this._productImage = image), this.updateProduct("image", image, !0), (this.placeholderImage = "");
    }
    get productLengthImage() {
        return this._productLengthImage;
    }
    set productLengthImage(image) {
        (this.els.length_image.element.src = image), (this._productLengthImage = image);
    }
    get charmSpacingItems() {
        return this._charmSpacingItems;
    }
    set charmSpacingItems(items) {
        const spacingItems = items === "" ? this.els.charm_spacings_group.element.dataset.default : items,
            spacingItemSplit = spacingItems.split(",");
        this.els.charm_spacings_group?.elements.forEach((trigger) => {
            let charmSpacingHTML = "";
            spacingItemSplit.forEach((item) => {
                trigger.dataset.type === "capsule"
                    ? (charmSpacingHTML += `<div class="vis-Info_Capsule" data-bespoke-visualiser-el="charm_spacing" data-max-charms="${this.typeCharmMax}" data-spacing="${item}">
            <p class="vis-Info_CapsuleTitle fz-14_171">${item}cm</p>

            <div class="vis-Info_CapsuleIcon">
              <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                <circle cx="10" cy="10" r="9.5" stroke="#2B2F2E"/>
                <path d="M5 10L8.5 13.5L15 7" stroke="#2B2F2E"/>
              </svg>
            </div>
          </div>`)
                    : (charmSpacingHTML += `<p class="vis-Charms_SpacingItem fz-12_20 charm_spacing__n${item}" data-bespoke-visualiser-el="charm_spacing" data-max-charms="${this.typeCharmMax}" data-spacing="${item}">${item}cm</p>`);
            }),
                (trigger.innerHTML = charmSpacingHTML);
        }),
            (this.charmSpacing = parseFloat(spacingItemSplit[spacingItemSplit.length - 1])),
            this.els.charm_spacing?.elements.forEach((trigger) => {
                this.listeners.add(trigger, "click", () => {
                    (this.charmMax = parseInt(trigger.dataset.maxCharms)), (this.charmSpacing = parseFloat(trigger.dataset.spacing)), (this.activeStage = null);
                });
            }),
            (this._charmSpacingItems = spacingItems);
    }
    get productLength() {
        return this._productLength;
    }
    set productLength(productLength) {
        this.els.product_length?.elements.forEach((product_length) => {
            product_length.classList.toggle("vis-Info_Capsule-selected", product_length.dataset.productLength === productLength), (product_length.ariaSelected = product_length.dataset.productLength === productLength);
        }),
            this.updateProduct("length", productLength, !1, "charms"),
            (this._productLength = productLength);
    }
    get variantId() {
        return this._variantId;
    }
    set variantId(variantId) {
        this.updateProduct("variant_id", parseInt(variantId)), (this._variantId = variantId);
    }
    get variantName() {
        return this._variantName;
    }
    set variantName(variantName) {
        this.updateProduct("variant_name", variantName), (this._variantName = variantName);
    }
    get productMaterial() {
        return this._productMaterial;
    }
    set productMaterial(productMaterial) {
        this.updateProduct("material", productMaterial), this.showCorrectMaterial(productMaterial), (this._productMaterial = productMaterial);
    }
    get collection() {
        return this._collection;
    }
    set collection(collection) {
      // /collections/${collection}?sections=bespoke-visualiser-style,bespoke-visualiser-length
        collection &&
            (this.updateProduct("collection", collection),
            fetch(`/collections/${collection}?sections=bespoke-visualiser-style,bespoke-visualiser-length`)
                .then((response) => response.json())
                .then((responseJSON) => {
                    this.els.stage?.elements.forEach((stage) => {
                        const sectionId = `bespoke-visualiser-${stage.dataset.stage}`;
                        console.log('sectionId', sectionId)
                        responseJSON[sectionId] && (getElement(".vis-Info_BodyTarget", { context: stage }).innerHTML = responseJSON[sectionId]);
                    }),
                        this.showCorrectMaterial(),
                        this.renderListeners();
                    const productStyle = this.urlParams.get("productStyle");
                    productStyle && this.clickProductStyle(productStyle), (this.productMaterial = this.els.product_material.element.dataset.productMaterial);
                     
                })
                .catch((e) => {
                    console.error(e);
                })),
            (this._collection = collection);
    }
    showCorrectMaterial(material) {
        const selectedMaterial = material ?? this.productMaterial;
        getElements("[data-selected-product-material]", { context: this }).forEach((element) => {
            element.ariaHidden = element.dataset.selectedProductMaterial !== selectedMaterial;
        }),
            this.els.product_material?.elements.forEach((product_material) => {
                product_material.classList.toggle("vis-MaterialFilter_Icon-selected", product_material.dataset.productMaterial === selectedMaterial);
            }),
            getElements(".vis-MaterialFilter_FilterTextActive", { context: this })?.forEach((activeText) => {
                activeText.innerHTML = selectedMaterial;
            }),
            (this.charmFilter = selectedMaterial);
    }
    async updateProduct(type, value, render, nextStage) {
        (this.visualiser.product[type] = value),
            this.els.stage_value.elements.forEach((stage) => {
                stage.dataset.stage === type && ((stage.innerHTML = value ?? "None selected"), type === "spacing" && (stage.innerHTML = `${stage.innerText}cm`), stage.classList.toggle("vis-Visualiser_StepValue-active", value));
            }),
            this.els.stage_show.elements.forEach((stage) => {
                stage.dataset.stage === type && (stage.dataset.completed = this.visualiser.product[type] !== null),
                    nextStage &&
                        (stage.dataset.stage === nextStage && this.visualiser.product[type] && (stage.ariaDisabled = !1),
                        nextStage === "length" && stage.dataset.stage === "spacing" && this.visualiser.product[type] && (stage.ariaDisabled = !1));
            }),
            render && (this.visualiser.product.previewImage = await this.bvCanvas.render(this.canvas, this.visualiser)),
            BVSummary.render(this.visualiser),
            this.renderCharmEdit();
    }
    async resetSelected() {
        (this.productStyle = null),
            (this.productLength = null),
            (this.productImage = ""),
            (this.variantId = null),
            (this.productPrice = null),
            (this.stage = null),
            this.els.stage_show.elements.forEach((stage) => {
                stage.dataset.stage !== "type" && stage.dataset.stage !== "style" && (stage.ariaDisabled = !0);
            });
    }
    get hideLength() {
        return this._hideLength;
    }
    set hideLength(hidden) {
        this.els.stage_show.elements.forEach((stage) => {
            stage.dataset.stage === "length" && (stage.ariaDisabled = hidden);
        }),
            (this._hideLength = hidden);
    }
    get charmSpacing() {
        return this._charmSpacing;
    }
    set charmSpacing(charmSpacing) {
        this.els.charm_spacing?.elements.forEach((charm_spacing) => {
            const className = charm_spacing.parentNode.dataset.type === "capsule" ? "vis-Info_Capsule-selected" : "vis-Charms_SpacingItem-selected";
            charm_spacing.classList.toggle(className, parseFloat(charm_spacing.dataset.spacing) === charmSpacing);
        }),
            this.updateProduct("spacing", charmSpacing, !0),
            (this._charmSpacing = charmSpacing);
    }
    get charmMax() {
        return this._charmMax;
    }
    set charmMax(charmMax) {
        (getElement(".vis-Visualiser_StepMaxValue", { context: this }).innerHTML = charmMax),
            this.els.charm_max.elements.forEach((element) => {
                element.innerHTML = charmMax;
            }),
            this.updateProduct("max", charmMax),
            this.updateCharm(charmMax, "max"),
            (this._charmMax = charmMax);
    }
    get charmScale() {
        return this._charmScale;
    }
    set charmScale(charmScale) {
        (this._charmScale = charmScale), this.updateProduct("charmScale", charmScale);
    }
    get charmPosition() {
        return this._charmPosition;
    }
    set charmPosition(charmPosition) {
        (this._charmPosition = charmPosition), this.updateProduct("charmPosition", charmPosition);
    }
    get charmFilter() {
        return this._charmFilter;
    }
    set charmFilter(charmFilter) {
        (getElements(this.selectors.charmFilter)?.filter((filter) => filter.dataset.material === charmFilter)).length > 0 &&
            (document.querySelectorAll(this.selectors.charmFilter).forEach((filter) => {
                filter.classList.toggle("vis-Charms_FilterIcon-selected", filter.dataset.material === charmFilter);
            }),
            getElements(".vis-Charms_FilterTextActive", { context: this })?.forEach((activeText) => {
                activeText.innerHTML = charmFilter;
            }),
            document.querySelectorAll(this.selectors.charm).forEach((charm) => {
                charm.ariaHidden = charm.dataset.charmMaterial ? charm.dataset.charmMaterial !== charmFilter : !1;
            }),
            window.dispatchEvent(new Event("resize"))),
            (this._charmFilter = charmFilter);
    }
    async updateCharm(value, action) {
        const matchCurrent = this.visualiser.charms.filter((obj) => obj.id === value.id);
        if ((action === "plus" && this.visualiser.charms.length === this.visualiser.product.max) || (action === "plus" && matchCurrent.length >= value.max)) return;
        switch (action) {
            case "remove":
                this.visualiser.charms = this.visualiser.charms.filter((obj, index) => index !== value);
                break;
            case "minus": {
                const removedIndex = this.visualiser.charms.findLastIndex((obj) => obj.id === value.id);
                this.visualiser.charms = this.visualiser.charms.filter((obj, index) => index !== removedIndex);
                break;
            }
            case "plus":
                this.visualiser.charms.length < this.visualiser.product.max && this.visualiser.charms.push(value);
                break;
            case "reorder":
                this.visualiser.charms = value;
                break;
            case "max":
                this.visualiser.charms = this.visualiser.charms.filter((obj, index) => index < value);
                break;
        }
        const removedDuplicateCharms = [...new Set(this.visualiser.charms)];
        document.querySelectorAll(this.selectors.charm).forEach((charm) => {
            charm.classList.toggle(
                "vis-Charms_Product-selected",
                removedDuplicateCharms.some((e) => e.id === parseInt(charm.dataset.charmId))
            ),
                (getElement(".vis-Charms_ProductQtyItem-qty", { context: charm }).innerHTML = this.visualiser.charms.filter((e) => e.id === parseInt(charm.dataset.charmId)).length);
        }),
            this.els.charm_selected.elements.forEach((charm_selected) => {
                (charm_selected.ariaHidden = !removedDuplicateCharms.some((e) => e.category === charm_selected.dataset.category)),
                    (getElement(".vis-Charms_HeaderSelectedText", { context: charm_selected }).innerHTML = this.visualiser.charms.filter((e) => e.category === charm_selected.dataset.category).length);
            }),
            this.els.stage_value.elements.forEach((tile) => {
                tile.dataset.stage === "charms" && ((tile.innerHTML = this.visualiser.charms.length), tile.classList.toggle("vis-Visualiser_StepValue-active", this.visualiser.charms.length));
            }),
            getElements(".vis-Visualiser_StepMax", { context: this }).forEach((maxValue) => {
                maxValue.classList.toggle("vis-Visualiser_StepMax-active", this.visualiser.charms.length);
            }),
            (this.els.bottomInfo.element.ariaHidden = this.visualiser.charms.length === 0);
        const matchCurrentNew = this.visualiser.charms.filter((obj) => obj.id === value.id);
        getElements(`[data-charm-id="${value.id}"] .vis-Charms_ProductQtyItem-plus`).forEach((charm) => {
            charm.classList.toggle("vis-Charms_ProductQtyItem-disabled", matchCurrentNew.length === value.max);
        }),
            action !== "reorder" && (this.visualiser.product.previewImage = await this.bvCanvas.render(this.canvas, this.visualiser)),
            BVSummary.render(this.visualiser),
            this.renderCharmEdit(),
            this.els.summary_button.elements.forEach((button) => {
                button.disabled = this.visualiser.charms.length <= 0;
            }),
            (this.els.step_summary.element.ariaHidden = this.visualiser.charms.length === 0);
    }
    get summary() {
        return this._summary;
    }
    set summary(hidden) {
        (this.els.summary.element.ariaHidden = hidden), (getElement(".vis-Visualiser_Column-selectors", { context: this }).ariaHidden = !hidden), (this._summary = hidden);
    }
    get charmMaxUpdate() {
        return this._charmMaxUpdate;
    }
    set charmMaxUpdate(values) {
        const valuesArr = values.toString().split(",");
        this.els.charm_spacing?.elements.forEach((charm_spacing, i) => {
            valuesArr[i]
                ? (charm_spacing.dataset.maxCharms = valuesArr[i] === "0" ? this.typeCharmMax : parseFloat(valuesArr[i]))
                : (charm_spacing.dataset.maxCharms = valuesArr[i] === "0" ? this.typeCharmMax : parseFloat(valuesArr[valuesArr.length - 1])),
                parseFloat(charm_spacing.dataset.spacing) === this.visualiser.product.spacing && (this.charmMax = valuesArr[i] === "0" ? this.typeCharmMax : parseFloat(charm_spacing.dataset.maxCharms));
        }),
            (this._charmMaxUpdate = values);
    }
    get typeCharmMax() {
        return this._typeCharmMax;
    }
    set typeCharmMax(value) {
        this._typeCharmMax = value;
    }
    get designSlideOut() {
        return this._designSlideOut;
    }
    set designSlideOut(hidden) {
        (this.els.design.element.ariaHidden = hidden), this.initialiseDesignCarousel(), (this._designSlideOut = hidden);
    }
    get giftingBar() {
        return this.querySelector("gift-bar");
    }
    get hasGifting() {
        return this.giftingBar ? this.giftingBar.hasGifting : !1;
    }
}
class BVSummary {
    static render(object) {
        (getElement('[data-summary="image"]').src = object.product.previewImage),
            (getElement('[data-summary="type"]').innerHTML = object.product.type),
            (getElement('[data-summary="style"]').innerHTML = object.product.style),
            (getElement('[data-summary-price="style"]').innerHTML = formatMoney(object.product.price)),
            (getElement('[data-summary="length"]').innerHTML = object.product.length);
        let charmsHTML = "";
        object.charms.forEach((charm, index) => {
            let lines = [];
            if (charm.engraving_text) {
                const engravingText = JSON.parse(charm.engraving_text);
                for (const pair of engravingText) lines = [...lines, pair[1]];
            }
            const engravingHTML = charm.engraving_text ? `<p class="vis-Summary_RowTextTitle fz-12_22">${theme.strings.bespoke.engraving} "${lines}"</p>` : "";
            charmsHTML += `<div class="vis-Summary_RowValue">
        <div class="vis-Summary_RowText">
          <p class="vis-Summary_RowTextTitle fz-14_171">${index + 1}. ${charm.name}</p>
          ${engravingHTML}
        </div>
        <p class="vis-Summary_RowPrice fz-14_171">${formatMoney(charm.price)}</p>
        <p class="vis-Summary_RowEdit btn-Button btn-Button-underline fz-14_171" data-bespoke-visualiser-el="summary_edit" data-summary-edit="charms">${theme.strings.bespoke.edit}</p>
      </div>`;
        }),
            getElement("bespoke-visualiser").dataset.showSpacing === "true" &&
                (charmsHTML += `<div class="vis-Summary_RowValue">
        <p class="vis-Summary_RowText fz-14_171">Spacing: ${object.product.spacing}cm</p>
        <p class="vis-Summary_RowPrice vis-Summary_RowPrice-na fz-14_171">${theme.strings.bespoke.na}</p>
        <p class="vis-Summary_RowEdit btn-Button btn-Button-underline fz-14_171" data-bespoke-visualiser-el="summary_edit" data-summary-edit="spacing">${theme.strings.bespoke.edit}</p>
      </div>`),
            (getElement('[data-summary-group="charms"]').innerHTML = charmsHTML),
            getElement('[data-summary="design"]') && (getElement('[data-summary="design"]').innerHTML = object.product.base_variant_name),
            getElement('[data-summary-price="design"]') && (getElement('[data-summary-price="design"]').innerHTML = formatMoney(object.product.base_variant_price)),
            getElement('[data-summary="design_text"] strong') && (getElement('[data-summary="design_text"] strong').innerHTML = object.product.base_variant_name?.toLowerCase());
        const totalCharmPrice = object.charms.reduce((accumulator, currentValue) => accumulator + currentValue.price, 0),
            productPrice = object.product.price,
            shippingPrice = object.product.base_variant_price;
        getElements("[data-summary-total]").forEach((total) => {
            total.innerHTML = formatMoney(productPrice + totalCharmPrice + shippingPrice);
        });
    }
    static async addToCart(object, BV) {
        let items = [];
        console.log('object', object);
        console.log('BV', BV)
        // items.push({ id: object.product.base_variant_id, quantity: 1 });
        const bespokeId = new Date().getTime();
        object.charms.forEach((charm, index) => {
                const charmProps = { _bespoke: bespokeId, _position: index + 1 };
                if (charm.engraving_text) {
                    const engravingObj = JSON.parse(charm.engraving_text);
                    (charmProps._engraving_font = charm.engraving_font),
                        engravingObj.forEach((element) => {
                            charmProps[`Engraving_${element[0]}`] = element[1];
                        });
                }
                items.push({ id: charm.variant_id, quanitity: 1, properties: charmProps });
        });
        items.push({ id: object.product.variant_id, quantity: 1, properties: { _bespoke: bespokeId, _spacing: object.product.spacing } });
        console.log('items', items);
        let data = {
          items: items
        }
        jQuery.ajax({
          type: 'POST',
          url: '/cart/add.js',
          data: data,
          dataType: 'json',
          success: function() { 
            console.log("OKKK!!!!!");
            window.location.href = "/cart";
          },
          error: function (e) {
            console.log("service.addItem() ERROR!"), console.log(e);
          }
        });      
      
    }
}
class BVCanvas {
    constructor() {
        document.querySelector(".vis-Zoom").addEventListener("click", (e) => {
            e.preventDefault(), this.onZoomClick();
        });
    }
    async render(canvas, visualiser) {
        (this.visualiser = visualiser),
            (this.charmScale = visualiser.product.charmScale / 1e3),
            (this.charmPosition = visualiser.product.charmPosition / 100),
            canvas.classList.add("vis-Visualiser_Canvas-loading"),
            await new Promise((resolve, reject) => setTimeout(resolve, 200));
        const minDimension = Math.min(canvas.offsetWidth, canvas.offsetHeight);
        if (((this.stage = new Konva.Stage({ container: "vis-Visualiser_Canvas", width: minDimension, height: minDimension })), !!visualiser.product.image))
            return (
                await this.generateProductImage(visualiser),
                await this.generateCharmImages(visualiser),
                this.visualiser.charms.length && this.zoomed !== !1 && (this.zoomed = !0),
                this.stage.setAttrs(this.zoomOptions),
                canvas.classList.remove("vis-Visualiser_Canvas-loading"),
                this.generatePreview()
            );
    }
    generatePreview() {
        const isZoomed = this.zoomed;
        isZoomed && ((this.zoomed = !1), this.stage.setAttrs(this.zoomOptions));
        const preview = this.stage.toDataURL({ mimeType: "image/jpeg" });
        return isZoomed && ((this.zoomed = !0), this.stage.setAttrs(this.zoomOptions)), preview;
    }
    async generateProductImage() {
        const productLayer = new Konva.Layer(),
            productImg = await this.createImage(this.visualiser.product.image),
            productImage = new Konva.Image({ image: productImg, x: 0, y: 0, width: this.stageWidth, height: this.stageWidth, fill: "#fbf7f4", draggable: !1 });
            if (productImage.getAttr("data-summary") === "image") {
                productImage.fill("#fdeff2");
            }      
        productLayer.add(productImage), this.stage.add(productLayer);
    }
    async generateCharmImages() {
        const charmLayer = new Konva.Layer(),
            charmCount = this.visualiser.charms.length,
            points = this.generatePoints(),
            start = 180,
            spacing = this.visualiser.product.spacing * 8;
        let offset = Math.round(start + (spacing * (charmCount - 1)) / 2);
        await Promise.all(
            this.visualiser.charms.map((charm, index) => {
                const point = points[offset],
                    rotation = offset + start;
                return (offset = Math.round(offset - spacing)), this.generateCharmImage(charmLayer, charm, index, point, rotation);
            })
        ), 
            this.stage.add(charmLayer),
            this.bindDragDrop(charmLayer);
    }
    async generateCharmImage(charmLayer, charm, index, point, rotation) {
        const charmImg = await this.createImage(charm.image),
            size = this.stageWidth * this.charmScale * 3, 
            hitboxScale = 10,
            charmImage = new Konva.Image({ x: hitboxScale / 2, y: 0, image: charmImg, width: size, height: size }),
            hitBox = new Konva.Rect({ width: size + hitboxScale, height: size + hitboxScale }),
            charmGroup = new Konva.Group({ draggable: !0, x: point.x, y: point.y, rotation, offsetX: (size + hitboxScale) / 2, charmIndex: index });
        charmGroup.add(hitBox),
            charmGroup.add(charmImage),
            charmGroup.on("mouseenter", this.onCharmHover),
            charmGroup.on("mouseleave", this.onCharmBlur),
            charmGroup.on("click tap", () => this.onCharmClick(charmGroup)),
            charmLayer.add(charmGroup);
    }
    bindDragDrop(charmLayer) { 
        const tempLayer = new Konva.Layer();
        this.stage.add(tempLayer);
        let currentCharm, targetCharm, initialX, initialY, initialRotation;
        this.stage.on("dragstart", (e) => {
            (currentCharm = e.target), (initialX = currentCharm.attrs.x), (initialY = currentCharm.attrs.y), (initialRotation = currentCharm.attrs.rotation), currentCharm.moveTo(tempLayer), charmLayer.draw();
        }),
            this.stage.on("dragmove", (e) => {
                const pos = this.stage.getPointerPosition(),
                    newTargetCharm = charmLayer.getIntersection(pos)?.parent;
                targetCharm && !newTargetCharm && targetCharm.to({ scaleX: 1, scaleY: 1, duration: 0.15 }),
                    newTargetCharm && newTargetCharm !== targetCharm && newTargetCharm.to({ scaleX: 1.15, scaleY: 1.15, duration: 0.15 }),
                    (targetCharm = newTargetCharm);
            }),
            this.stage.on("dragend", (e) => {
                targetCharm
                    ? (currentCharm.to({ x: targetCharm.attrs.x, y: targetCharm.attrs.y, rotation: targetCharm.attrs.rotation, scaleX: 1, scaleY: 1, duration: 0.35 }),
                      targetCharm.to({
                          x: initialX,
                          y: initialY,
                          rotation: initialRotation,
                          scaleX: 1,
                          scaleY: 1,
                          duration: 0.35,
                          onFinish: () => {
                              const previewImage = this.generatePreview();
                              document.dispatchEvent(new CustomEvent("visualiser:updatePreview", { detail: { previewImage } }));
                          },
                      }),
                      this.swapCharms(currentCharm, targetCharm))
                    : currentCharm.to({ x: initialX, y: initialY, scaleX: 1, scaleY: 1, duration: 0.35 }),
                    currentCharm.moveTo(charmLayer),
                    (currentCharm = null),
                    (targetCharm = null);
            });
    }
    generatePoints() {
        const centerX = this.stageWidth * 0.5,
            centerY = this.stageWidth * 0.5,
            radius = this.stageWidth * this.charmPosition,
            points = [];
        for (let degree = -90; degree < 270; degree++) {
            const radians = (degree * Math.PI) / 180,
                x = centerX + radius * Math.cos(radians),
                y = centerY + radius * Math.sin(radians);
            points.push({ x, y });
        }
        return points;
    }
    createImage(url) {
        return new Promise((resolve, reject) => {
            const image = new Image();
            (image.crossOrigin = ""), image.addEventListener("load", () => resolve(image)), image.addEventListener("error", (error) => reject(error)), (image.src = url);
        });
    }
    onCharmHover() {
        this.to({ scaleX: 1.15, scaleY: 1.15, duration: 0.15 }), (document.body.style.cursor = "pointer");
    }
    onCharmBlur() {
        this.to({ scaleX: 1, scaleY: 1, duration: 0.15 }), (document.body.style.cursor = "default");
    }
    onCharmClick(charmGroup) {
        document.dispatchEvent(new CustomEvent("visualiser:remove", { detail: { index: charmGroup.attrs.charmIndex } }));
    }
    onZoomClick() {
        (this.zoomed = !this.zoomed), this.stage.to(this.zoomOptions);
    }
    swapCharms = (charm1, charm2) => {
        const charm1Index = charm1.attrs.charmIndex,
            charm2Index = charm2.attrs.charmIndex,
            temp = this.visualiser.charms[charm1Index];
        (this.visualiser.charms[charm1Index] = this.visualiser.charms[charm2Index]),
            (this.visualiser.charms[charm2Index] = temp),
            (charm1.attrs.charmIndex = charm2Index),
            (charm2.attrs.charmIndex = charm1Index),
            document.dispatchEvent(new CustomEvent("visualiser:reorder", { detail: { charms: this.visualiser.charms } }));
    };
    get stage() {
        return this._stage;
    }
    set stage(stage) {
        this._stage = stage;
    }
    get stageWidth() {
        return this.stage.width();
    }
    get zoomOptions() {
        const spacing = this.visualiser.product.spacing,
            charmCount = this.visualiser.charms.length;
        let scale = 1,
            x = 0,
            y = 0;
        return (
            this.zoomed && ((scale = 2 - (charmCount * spacing) / 10), scale > 1 ? ((x = -(this.stageWidth * ((scale - 1) / 2))), (y = -(this.stageWidth * (scale - 1) + this.stageWidth / 4))) : (scale = 1)),
            { scaleX: scale, scaleY: scale, x, y }
        );
    }
    get zoomed() {
        return this._zoomed;
    }
    set zoomed(zoom) {
        (this._zoomed = zoom), document.querySelector(".vis-Zoom").classList.toggle("vis-Zoom-zoomed", zoom);
    }
}
customElements.get("bespoke-visualiser") || customElements.define("bespoke-visualiser", bespokeVisualiser);
//# sourceMappingURL=/cdn/shop/t/378/assets/bespoke-visualiser.js.map?v=161548230423813913291743754318
